<div [attr.data-name]="name" [ngClass]="['avatar', getBackgroundColor()]">
  <img src="{{ imageUrl }}" (error)="onImageLoadError()" *ngIf="showImage" />
  <ng-container *ngIf="!showImage">
    {{ initials }}
  </ng-container>
</div>
